import { render } from "./about-component.vue?vue&type=template&id=5e82c1bc&scoped=true"
import script from "./about-component.vue?vue&type=script&lang=js"
export * from "./about-component.vue?vue&type=script&lang=js"

import "./about-component.vue?vue&type=style&index=0&id=5e82c1bc&scoped=true&lang=css"

import exportComponent from "C:\\Users\\ahmed.shaker.KORABIA\\Desktop\\hesabtech-website\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e82c1bc"]])

export default __exports__